import { render, staticRenderFns } from "./TagIndicators.vue?vue&type=template&id=211da22b&scoped=true&"
import script from "./TagIndicators.vue?vue&type=script&lang=ts&"
export * from "./TagIndicators.vue?vue&type=script&lang=ts&"
import style0 from "./TagIndicators.vue?vue&type=style&index=0&id=211da22b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "211da22b",
  null
  
)

export default component.exports